/* Native disclosures also work without JavaScript and after editor reloads. */
if (!customElements.get("hulii-v2-navigation")) {
  customElements.define(
    "hulii-v2-navigation",
    class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const desktop = [...this.querySelectorAll(".hv2-desktop-menu details")];
        const hover = matchMedia("(hover:hover) and (pointer:fine)");
        const reduced = matchMedia("(prefers-reduced-motion:reduce)");
        const mobileToggle = this.querySelector(".hv2-mobile-toggle");
        const mobilePanel = this.querySelector(".hv2-mobile-menu nav");
        const close = () => {
          mobilePanel.hidden = true;
          mobileToggle.setAttribute("aria-expanded", "false");
          clearTimeout(this.closeTimer);
          this.querySelectorAll("details").forEach((item) => {
            item.open = false;
          });
        };
        mobileToggle.addEventListener(
          "click",
          () => {
            const opening = mobilePanel.hidden;
            close();
            mobilePanel.hidden = !opening;
            mobileToggle.setAttribute("aria-expanded", String(opening));
          },
          options,
        );
        const position = (item) => {
          const panel = item.querySelector(".hv2-submenu");
          const header =
            this.querySelector(".hv2-header-row").getBoundingClientRect();
          const trigger = item.querySelector("summary").getBoundingClientRect();
          panel.style.left = `${Math.max(16, Math.min(trigger.left - header.left - 22, header.width - panel.offsetWidth - 16))}px`;
          panel.style.transformOrigin = `${trigger.left - panel.getBoundingClientRect().left + trigger.width / 2}px top`;
        };
        const open = (item, keyboard = false) => {
          clearTimeout(this.closeTimer);
          desktop
            .filter((other) => other !== item)
            .forEach((other) => {
              other.open = false;
            });
          const wasOpen = item.open;
          item.open = true;
          position(item);
          if (!wasOpen && !keyboard && !reduced.matches) {
            const panel = item.querySelector(".hv2-submenu");
            panel.getAnimations().forEach((animation) => animation.cancel());
            panel.animate(
              [
                { opacity: 0, transform: "translateY(-4px) scale(.98)" },
                { opacity: 1, transform: "none" },
              ],
              { duration: 160, easing: "cubic-bezier(.23,1,.32,1)" },
            );
          }
        };
        desktop.forEach((item) => {
          const summary = item.querySelector("summary");
          item.addEventListener(
            "pointerenter",
            (event) => {
              if (event.pointerType === "mouse" && hover.matches) open(item);
            },
            options,
          );
          item.addEventListener(
            "pointerleave",
            (event) => {
              if (event.pointerType === "mouse" && hover.matches) {
                clearTimeout(this.closeTimer);
                this.closeTimer = setTimeout(() => {
                  item.open = false;
                }, 180);
              }
            },
            options,
          );
          summary.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              if (event.pointerType === "mouse" && hover.matches) open(item);
              else if (item.open) item.open = false;
              else open(item, event.detail === 0);
            },
            options,
          );
          summary.addEventListener(
            "keydown",
            (event) => {
              if (event.key === "ArrowDown") {
                event.preventDefault();
                open(item, true);
                item.querySelector(".hv2-submenu a").focus();
              }
            },
            options,
          );
        });
        this.addEventListener(
          "keydown",
          (event) => {
            this.setAttribute("data-keyboard", "");
            if (event.key !== "Escape") return;
            const opened =
              event.target.closest("details[open]") ||
              this.querySelector("details[open]");
            if (!opened && !mobilePanel.hidden) {
              close();
              mobileToggle.focus();
              event.preventDefault();
            }
            if (opened) {
              opened.open = false;
              opened.querySelector("summary").focus();
              event.preventDefault();
            }
          },
          options,
        );
        this.addEventListener(
          "pointerdown",
          () => this.removeAttribute("data-keyboard"),
          options,
        );
        document.addEventListener(
          "pointerdown",
          (event) => {
            if (!this.contains(event.target)) close();
          },
          options,
        );
        this.addEventListener(
          "focusout",
          (event) => {
            if (event.relatedTarget && !this.contains(event.relatedTarget))
              close();
          },
          options,
        );
        window.addEventListener("resize", close, options);
        const scroll = () =>
          this.classList.toggle("is-scrolled", window.scrollY > 8);
        window.addEventListener("scroll", scroll, {
          ...options,
          passive: true,
        });
        scroll();
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.closeTimer);
      }
    },
  );
}
